import React, { useRef } from 'react';
import './contact.css'

const Contact = () => {

    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
      };

  return (
    <section id='contact'>
        <div className='contact-container'>
            <h1>CONTACT US</h1>
            <p>GET IN TOUCH TODAY</p>
            <div className='contact-form-img-container'>
                <div className='contact-form'>
                    <form className="contact--form--container"  ref={form} onSubmit={sendEmail}>
                        <div className="container">
                        <label htmlFor="first-name" className="contact--label">
                            <span className="text-md">First Name</span>
                            <input
                            type="text"
                            className="contact--input text-md"
                            name="user_fname"
                            id="first-name"
                            required
                            />
                        </label>
                        <label htmlFor="last-name" className="contact--label">
                            <span className="text-md">Last Name</span>
                            <input
                            type="text"
                            className="contact--input text-md"
                            name="user_lname"
                            id="last-name"
                            required
                            />
                        </label>
                        <label htmlFor="email" className="contact--label">
                            <span className="text-md">Email</span>
                            <input
                            type="email"
                            className="contact--input text-md"
                            name="user_email"
                            id="email"
                            required
                            />
                        </label>
                        <label htmlFor="phone-number" className="contact--label">
                            <span className="text-md">Phone Number</span>
                            <input
                            type="number"
                            className="contact--input text-md"
                            name="user_phone"
                            id="phone-number"
                            required
                            />
                        </label>
                        </div>
                        <label htmlFor="message" className="contact--label">
                            <span className="text-md">Message</span>
                            <textarea
                                className="contact--input text-md"
                                name="message-textarea"
                                id="message-textarea"
                                rows="3"
                                placeholder="Type your message..."
                            />
                        </label>
                        <div>
                        <button className="btn btn-primary contact--form--btn" type="submit">Submit</button>
                        </div>
                    </form>
                </div>
                <div className='contact-image'>
                    <img className='contact-img' src="./img/contact-us.png" alt="" />
                </div>
            </div>
        </div>
    </section>
  )
}

export default Contact